import { StepperProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: StepperProps = {
  activeStep: 0,
  steps: [
    { text: 'This is a long step name' },
    { text: 'This is a long step name', type: 'disabled' },
    { text: 'This is a long step name', type: 'disabled' },
  ],
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as StepperProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
